import {Template, Component, Attribute} from '@scoutgg/ftw/source/lib'
import template from './event-selector.jade'
import '@scoutgg/ftw/source/atoms/icons/icons'
import shortcuts from '../../services/shortcuts'
import getState from '../../services/event-state'
import {Match} from '../../models'

@Component('sporty')
@Template(template)
@Attribute('match', Match)
export default class EventSelector extends HTMLElement {
  get events() {
    return getState(this.match).mainEvents
  }
  get sortedEvents() {
    return this.events
  }
  eventName(ev) {
    return getState(this.match).eventName(ev)
  }
  created() {
    this.shortcuts = 'qwertyuiop'.split('')
  }
  select(event) {
    getState(this.match).assignMainType(event)
  }
  eventClass(event) {
    if(getState(this.match).isEvent(event)) return 'active'
  }
  eventIcon(event) {
    if(event === 'substitution_1') event = 'sub'
    return ('events--' + this.match.sport + '--' + event)
  }
  attached() {
    getState(this.match).listen(this)
    this.unlisten = shortcuts(this.shortcuts, (key, n) => {
      this.select(this.events[this.shortcuts.indexOf(key)])
    })
  }
  matchChange() {
    getState(this.match).listen(this)
  }
  detached() {
    // It's possible for a detached event to happen before any attached events
    if(this.unlisten) this.unlisten()
  }
}
